import {useState, useEffect} from 'react';
import { useIsMobile } from 'hooks/useIsMobile';
import { getCardData } from 'services/Cards'
import { useToken } from 'hooks/useToken'
import { useHistory } from 'react-router-dom'
import { decodeStorage, encodeStorage } from 'functions/storageBase64'
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'

export function useConsultaSaldoPage(){

    const { isMobile } = useIsMobile();
    //const { newToken, liveToken }  = useToken({firstActive: false, name: "consultar saldo", timeRef: 1000 })
    const history = useHistory()
    const cardending = decodeStorage('cardending')
    const lastConsultData = decodeStorage('lastConsultData')
    const sears_numero_internet = decodeStorage('sears_numero_internet')
    const [udCard, setUdCard] = useState(false)
    
    
    const [response, setResponse] = useState(lastConsultData)
    const [noInternet, setNoInternet] = useState(sears_numero_internet)
    
    /*  --------------------------- Inicio --------------------------------------  */
    const timeToken  = useToken({firstActive: false, name: "consultar saldo", timeRef: 1000 })
    const [actionOK, setActionOk] = useState(false)
        useEffect(() => {
            setTimeout(function(){
                setActionOk('ready')
            },700)
        }, [])
   /*  --------------------------- Inicio Peticiones --------------------------------------  */
        //  Ajusta Los tiempos y refresca token
        const [serviceRT, setServiceRT] = useState(false)
        useEffect(()=>{
            if(actionOK){
                let  actTimeLS = Date.now()
                let  atExpLS = decodeStorage('access_token_exp') * 1000
    
                // console.log('------------------------------')
                // console.log('actTimeLS   : ', new Date() )
                // console.log('actTimeLS m : ', ( new Date( Date.now() + 180000) ) )
                // console.log('atExp   : ', new Date (atExpLS) )
                // console.log('time ok : ', actTimeLS <= atExpLS)
                // console.log('actionOK: ', actionOK)
                // console.log('------------------------------')
                
                if(actTimeLS <= atExpLS || Date.now() <= (decodeStorage('access_token_exp') * 1000) ){
                    setServiceRT(true)
                }
                else{
                    timeToken.forceToken(true)
                }
            }
        },[timeToken.newToken, actionOK])
    /*  --------------------------- Fin --------------------------------------  */

    useEffect(()=>{
        if(serviceRT){
            if(sears_numero_internet && ( cardending && (cardending != "undefined" && cardending != "dW5kZWZpbmVk" ) ) ){
                if(udCard){
                    getCardData(sears_numero_internet, decodeStorage('cardending'))
                    .then(setResponse)
                    setNoInternet(sears_numero_internet, decodeStorage('cardending'))
                    setUdCard(false)
                }
            }
        }
    },[serviceRT, udCard])
    
    // useEffect(()=>{

    //     if(sears_numero_internet != "undefined"  && (cardending != "undefined" || cardending != "dW5kZWZpbmVk" ) ){
    //         if(udCard){
    //             liveToken()
    //             getCardData(sears_numero_internet, cardending)
    //             .then(setResponse)
    //             setNoInternet(sears_numero_internet, cardending)
    //             setUdCard(false)
    //             console.log('asdas')
    //             console.log('10')
    //         }
    //     }
    // },[newToken, udCard])

    const [cardsService, setCardsService] = useState()
    const [errorCode, setErrorCode] = useState()
    useEffect(()=>{

        //console.log('response: ',response)
        if(response){
            if(response.statusCode === 200){
                let dataProduct = response.data
                dataProduct[0].noInternet = sears_numero_internet

                if(response?.data[0]?.credit_imit && response?.data[0]?.credit_available){
                    encodeStorage("montoCredito", response?.data[0]?.credit_imit);
                    encodeStorage("creditoDisponible", response?.data[0]?.credit_available);
                }

                setCardsService(dataProduct)
            }else if(response.statusCode >= 400 && response.statusCode <= 499){
                let codeError = JSON.parse(response.data)
                setErrorCode(codeError)
            }
            else if(response.statusCode >= 500 ){
                setErrorCode(response.statusCode)
                // console.log('as: ',response.statusCode)
            }
        }
    },[response])

    
    useEffect(()=>{
        if(cardsService && cardsService.length === 0){
            history.push(`${BASE_PATH}${SUB_DIRECTORY}home`)
        }
        else if(!sears_numero_internet || sears_numero_internet === "undefined"){
            history.push(`${BASE_PATH}${SUB_DIRECTORY}home`)
        }
    },[cardsService])

    return{
        cardsService,
        setUdCard,
        noInternet,
        errorCode,
        isMobile
    }
}